module.exports = {
    apiKey: "AIzaSyBhJ9WlweOYseYs_MzTXTzHLjqmRviQSyI",
    authDomain: "jsonforms-swagger.firebaseapp.com",
    databaseURL: "https://jsonforms-swagger.firebaseio.com",
    storageBucket: "jsonforms-swagger.appspot.com"
};


/*****************
 ** WEBPACK FOOTER
 ** ./firebase.conf.js
 ** module id = 260
 ** module chunks = 0
 **/